import React from 'react'
import { Route, Switch } from 'react-router-dom'
// import PageLayout from 'layouts/PageLayout'

const AppRouter = () => {
  return (
    <Switch>
      <Route
        path='/topUp/international'
        render={(routeProps) => (
          <div>
            {require('./List').default(routeProps)}
            {require('./Country').default(routeProps)}
            {require('./Operator').default(routeProps)}
            {require('./Recharge').default(routeProps)}
          </div>
        )}
      />
    </Switch>
  )
}

export default AppRouter
